/** work-around for making standalone builds work in older versions of Nx **/
/** TODO: Remove this when we upgrade to Nx 16.3.0+ **/
import path from 'path'
path.resolve(__dirname, '../next.config.js')

export {
  getServerSideProps,
  Homepage as default,
} from '@cinch-nx/landing-feature-homepage'
